import React, { useEffect, useRef } from 'react';
import { loadRaffleArtwork, paintWinnerTicket, TICKET_WIDTH, TICKET_HEIGHT } from './raffleArtwork';

// Preserve the same coupon and actions when a device cannot render WebGL.
export default function RaffleWinnerFallback({ winner }) {
  const canvas = useRef(null);
  useEffect(() => {
    let active = true;
    loadRaffleArtwork().then(artwork => {
      if (active) paintWinnerTicket(canvas.current, winner, artwork);
    });
    return () => { active = false; };
  }, [winner]);
  return <div style={{ position: 'absolute', inset: '17% 6% 20%' }}>
    <canvas ref={canvas} width={TICKET_WIDTH} height={TICKET_HEIGHT} aria-label="Cupón ganador"
      style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }} />
  </div>;
}
